export function fixBarcode(input) {
  const map = {
    'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p',
    'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l',
    'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm',
    'ё': '`', 'ъ': '[', 'э': ']', 'ж': ';', 'б': ',', 'ю': '.', 'х': '\'',
  };

  return input.replace(/[а-яё]/gi, m => map[m.toLowerCase()] || m).toUpperCase();
}